import React, {useEffect} from 'react'
import gql from 'graphql-tag'
import {notification} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import {Mutation} from 'react-apollo'
import Heading from 'components/shared/Heading'
import {estateQuery} from 'components/shared/EstateLayout'
import Button from 'components/shared/Button'
import {formatKm} from 'lib/util'

const purchaseAreaPhotosMutation = gql`
  mutation PurchaseAreaPhotos($input: PurchaseAreaPhotosInput!) {
    PurchaseAreaPhotos(input: $input) {
      productsEdge {
        node {
          id
          state
        }
      }
    }
  }
`

const SelectedPhoto = ({photo, onRemove}) => {
  return (
    <div className="selected-photo">
      <div className="thumb">
        <img src={photo.thumb.url} alt="" />
      </div>
      <div className="content">
        <span className="title">{photo.name}</span>
        <span className="description">{formatKm(photo.distanceInKm)}</span>
      </div>
      <div className="remove">
        <Button icon={<CloseOutlined />} onClick={() => onRemove(photo)} />
      </div>
    </div>
  )
}

const Approve = ({
  estateId,
  selectedPhotos,
  selectedPhotosReducer,
  setStep,
  onPurchased,
}) => {
  useEffect(() => {
    if (selectedPhotos.length === 0) {
      setStep('browse')
    }
  }, [selectedPhotos, setStep])

  const removePhoto = (photo) => {
    selectedPhotosReducer({type: 'remove', photo})
  }

  return (
    <>
      <Heading level={2}>Se over valgte bilder fra nærområdet</Heading>

      <div className="selected-photos">
        {selectedPhotos.map((photo, i) => (
          <SelectedPhoto
            key={`${photo.id}-${i}`}
            photo={photo}
            onRemove={removePhoto}
          />
        ))}
      </div>

      <div className="actions">
        <Button
          secondary
          type="navigation"
          onClick={() => setStep('browse')}
        >
          Gå tilbake
        </Button>
        <Mutation
          mutation={purchaseAreaPhotosMutation}
          refetchQueries={[
            {query: estateQuery, variables: {id: estateId}}
          ]}
          onCompleted={(data) => {
            notification['success']({
              message: 'Områdebilder kjøpt',
              description: 'Valgte områdebilder er nå kjøpt og vil snart bli tilgjengelig for nedlastning.',
            })
            onPurchased(data.PurchaseAreaPhotos.productsEdge.node)
          }}
          onError={() => {
            notification['error']({
              message: 'Kjøp feilet',
              description: 'Valgte områdebilder kunne ikke kjøpes grunnet en feil. Forsøk på nytt senere.',
            })
          }}
        >
          {(purchasePhotos, {loading}) => {
            return (
              <Button
                type="action"
                loading={loading}
                disabled={loading}
                onClick={() => {
                  purchasePhotos({variables: {
                    input: {
                      estateId,
                      assetIds: selectedPhotos.map(p => p.id),
                    }
                  }})
                }}
              >
                Fullfør
              </Button>
            )
          }}
        </Mutation>
      </div>
    </>
  )
}

export default Approve
